import { StateCreator } from 'zustand';

import {
  handleCloseRunView,
  handleRequestRunView,
  handleSetFullScreen,
  handleSetPresentedStatus,
} from './handlers';
import {
  DoBoxPageOpenHandler,
  DoBoxRunViewState,
  DoBoxRunViewStore,
  HandlerSet,
  RequestRunViewOptions,
} from './types';

export const INITIAL_DOBOX_RUN_VIEW_STATE: DoBoxRunViewState = {
  openByEntryId: {},
  pageOpenHandler: null,
  presentedStatusByEntryId: {},
};

export const createDoBoxRunViewSlice: StateCreator<DoBoxRunViewStore> = (
  set,
) => {
  const handlerSet: HandlerSet = (updater) => {
    if (typeof updater === 'function') {
      set((fullState) => updater(fullState) as Partial<DoBoxRunViewStore>);
    } else {
      set(updater as Partial<DoBoxRunViewStore>);
    }
  };

  return {
    ...INITIAL_DOBOX_RUN_VIEW_STATE,

    requestRunView: (entryId: string, options?: RequestRunViewOptions) =>
      handleRequestRunView(handlerSet, entryId, options),
    closeRunView: (entryId: string) => handleCloseRunView(handlerSet, entryId),
    setFullScreen: (entryId: string, fullScreen: boolean) =>
      handleSetFullScreen(handlerSet, entryId, fullScreen),
    setPresentedStatus: (entryId, override) =>
      handleSetPresentedStatus(handlerSet, entryId, override),
    setPageOpenHandler: (handler: DoBoxPageOpenHandler | null) =>
      set({ pageOpenHandler: handler }),
    reset: () => set(INITIAL_DOBOX_RUN_VIEW_STATE),
  };
};
